import { css } from '@emotion/core'
import styled from '@emotion/styled'

import { Spacing } from '../../../../enums/spacing'
import { MODAL_HORIZONTAL_PADDING } from '../../constants/modalHorizontalPadding'
import { Size } from '../../types/size'

interface ModalBodyWrapperProps {
  size?: Size
}

//  Warning! Don't use SimlpeBar here - it causes flickering in Modal when elements are re-reinitialized
export const ModalBodyWrapper = styled.div<ModalBodyWrapperProps>`
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
  width: 100%;
  padding: ${Spacing.S12} ${MODAL_HORIZONTAL_PADDING} ${Spacing.S24};
  overflow: auto;

  ${({ size }) =>
    size === 'fullScreen' &&
    css`
      flex: 1;
      min-height: 0;
    `}
`
